import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";

const NavBar = () => {
  const [state, setState] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar__items">
        <NavLink to="/">
          <img src="logo.svg" alt="logo" height="50" />
        </NavLink>

        <Link
          to="#"
          className={
            state
              ? "navbar__toggle hide-for-desktop open"
              : "navbar__toggle hide-for-desktop"
          }
          onClick={() => setState(!state)}
        >
          <span></span>
          <span></span>
          <span></span>
        </Link>

        <div className="hide-for-mobile">
          <NavLink to="/post" style={{ textDecoration: "none" }}>
            <span className="button">Blog</span>
          </NavLink>
          <NavLink to="/contact" style={{ textDecoration: "none" }}>
            <span className="btn-say-hello">Say Hello</span>
          </NavLink>
        </div>
      </div>
      <div
        className={
          state ? "hamburger-links open fade-in" : "hamburger-links fade-out"
        }
      >
        <ul>
          <li>
            <NavLink to="/post" style={{ textDecoration: "none" }}>
              <span className="button">Blog</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" style={{ textDecoration: "none" }}>
              <span className="btn-say-hello">Say Hello</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;
